import { textSort } from './strings'

export const getTextSort = getText => (a, b) => textSort(getText(a), getText(b))

export const getNumberSort = getNumber => (a, b) => getNumber(a) - getNumber(b)
